import { svgMarkerIcons, mapStyles } from './../utils/wappo.gmap.const'

let bounds = new google.maps.LatLngBounds();
let markers = new Array();
let locations = new Array();
const svgMarker = svgMarkerIcons[0];

function addMarkers(map)
{
	for (let i = 0; i < locations.length; i++)
	{
		const refactoredPosition = { lat: locations[i].position.latitude, lng: locations[i].position.longitude }

		let marker = new google.maps.Marker({
			id: locations[i].name,
			title: locations[i].name,
			position: refactoredPosition,
			map,
			icon: svgMarker,
			clickable: false
		});

		markers.push(marker);
		bounds.extend(refactoredPosition);
	}

	if (locations.length > 1)
	{
		map.fitBounds(bounds, 0);
	}
	else if (locations.length == 1)
	{
		map.setCenter({ lat: locations[0].position.latitude, lng: locations[0].position.longitude });
	}
}

function initMap()
{
	const map = new google.maps.Map(
		document.getElementById("map"),
		{
			zoom: 6,
			styles: mapStyles,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false
		}
	);

	// When map ready add markers
	google.maps.event.addListenerOnce(map, 'idle', function ()
	{
		addMarkers(map);
	});
}

$(document).ready(function ()
{
	const modelId = $("#map").data("model-id");

	// FETCH LOCATIONS
	$.ajax({
		url: "/gmap/locations/" + modelId,
		type: "GET",
		success: function (result)
		{
			locations = result;
			// adjust marker scale
			svgMarker.scale = (locations.length > 1 ? 0.06 : 0.08);

			initMap();
		},
		error: function (jqXHR, textStatus, errorThrown)
		{
			console.log("!AJAX ERROR! " + errorThrown);
		}
	});
});